export default {
  name: 'AddressErrorModal',
  props: {
    message: String
  },
  methods: {
    confirmError() {
      this.$emit('confirm');
    }
  }
};